/**
 * The base breakpoints for the Soft UI Dashboard PRO Material.
 * You can add new breakpoints using this file.
 * You can customize the breakpoints for the entire Soft UI Dashboard PRO Material using thie file.
 */

const breakPoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  },
} as const;

export type BreakPoints = typeof breakPoints;

export default breakPoints;
